import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import SideModal from "../../Components/SideModal";
import Table from "../../Components/EStamp/Table";
import { toast } from "react-toastify";
import SwitchStampModal from "../../Components/EStamp/SwitchStampModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SummaryCards from "../../Components/EStamp/SummaryCards";
import TableNew from "../../Components/EStamp/TableNew";
import ViewStampDetails from "../../Components/EStamp/ViewDetails";

const StampPaperListing = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty,
  );
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [summaryData, setSummaryData] = useState();
  const [isSwitchStamp, setIsSwitchStamp] = useState(false);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [selectedProperty, setSelectedProperty] = useState(property);

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/client/stamp/list`, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) {
      setApiData([]);
    } else {
      const data = res?.data || [];
      setApiData(data);
      setFilteredProperties(res?.properties);
      setSummaryData(res?.stats || []);
    }
  };

  const getError = () => {
    setApiData([]);
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 50);
    return () => clearTimeout(handler);
  }, [getListMutate]);

  const filteredData = selectedProperty?.id
    ? apiData?.filter((item) => item?.propId === selectedProperty?.id)
    : apiData;

  //------- Switch Stamp  -------
  const switchStampFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/stamp/shift`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const switchStampSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setIsSwitchStamp(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg);
    }
  };

  const switchStampError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: switchStampLoading, mutate: switchStampMutate } =
    useMutation(switchStampFunction, {
      onSuccess: switchStampSuccess,
      onError: switchStampError,
    });

  const handleSwitchStampClose = () => {
    setIsSwitchStamp(false);
  };

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            {"Stamp Papers"}
            <Underline />
          </BoxTitle>
        </BoxHead>
        {(isLoading || isRefetching) && <SummarySkeletonLoading count={3} />}
        {!error && !isLoading && data && summaryData && (
          <SummaryCards summaryData={summaryData} />
        )}

        <FilterTableWrapper>
          <FilterWrapper>
            <div className="flex items-center justify-between w-full">
              <Text>
                Total records:{" "}
                <span className="font-semibold">{apiData?.length || 0}</span>
              </Text>
              <div className="flex ustify-end items-center ml-auto">
                <PropertiesFilterDropdown
                  properties={filteredProperties}
                  selectedProperty={selectedProperty}
                  onPropertySelect={handlePropertySelect}
                  placeholder="Select Property"
                  className="min-w-[200px] w-full md:w-[220px]"
                />
              </div>
            </div>
          </FilterWrapper>
          {!error && !isLoading && data && (
            <TableWrapper>
              <TableNew
                apiData={error ? [] : filteredData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setViewDetails={setViewDetails}
                setIsSwitchStamp={setIsSwitchStamp}
              />
              {!error && filteredData?.length === 0 && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
        </FilterTableWrapper>

        {(isLoading || isRefetching) && <Loading />}
        <SideModal isOpen={viewDetails} onClose={() => setViewDetails(false)}>
          <ViewStampDetails
            setViewDetails={setViewDetails}
            selectedData={selectedData}
          />
        </SideModal>
        <SideModal
          isOpen={isSwitchStamp}
          onClose={() => setIsSwitchStamp(false)}
        >
          <SwitchStampModal
            setIsSwitchStamp={setIsSwitchStamp}
            selectedData={selectedData}
            handleClose={handleSwitchStampClose}
            switchStampLoading={switchStampLoading}
            switchStampMutate={switchStampMutate}
            properties={properties || []}
          />
        </SideModal>
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const Text = tw.p`text-gray-500 text-sm font-normal `;

export default StampPaperListing;
